export const tokens = {
    gap: {
        mobile: 32,
        desktop: 64,
    },
    titleSize: {
        mobile: 32,
        desktop: 40,
    },
    subtitleSize: {
        mobile: 18,
        desktop: 24,
    },
};
